export const DIMS = { "480p": [854, 480], "540p": [960, 540], "720p": [1280, 720], "1080p": [1920, 1080], "1440p": [2560, 1440], "4k": [3840, 2160] };
export const resList = (m) => Object.keys((m.billing === "tokens" ? m.usd_per_1k_tokens : m.usd_per_sec) || {}).concat(m.resolutions || []).filter((v, i, a) => a.indexOf(v) === i);

// Mirrors backend: token = w × h × 24 fps × (detik output + detik video referensi) ÷ 1024; ref video → tarif × ref_video_factor.
export function estimate(m, res, sec, refSec, audio) {
  if (m.billing === "tokens") {
    const [w, h] = DIMS[res] || [0, 0];
    const tokens = (w * h * 24 * (sec + refSec)) / 1024;
    const rate = Number(m.usd_per_1k_tokens?.[res] ?? 0) * (refSec > 0 ? Number(m.ref_video_factor ?? 1) : 1);
    return { tokens, usd: (tokens / 1000) * rate };
  }
  const per = audio ? m.usd_per_sec?.[res] : m.usd_per_sec_no_audio?.[res] ?? m.usd_per_sec?.[res];
  return { tokens: null, usd: Number(per ?? 0) * sec };
}

export function toCredits(usd, p) {
  if (!p) return null;
  const margin = Number(p.margin_overrides?.video ?? p.margin_pct ?? 0); const tax = Number(p.tax_pct ?? 0);
  return { margin, tax, credits: (usd * (1 + margin / 100) * (1 + tax / 100)) / Number(p.usd_per_credit || 1) };
}

export const REF_LABELS = { max_images: "Maks gambar", max_image_mb: "Ukuran gambar (MB)", max_videos: "Maks video", max_video_mb: "Ukuran video (MB)", min_video_sec: "Durasi video min (dtk)", max_video_sec: "Durasi video maks (dtk)", max_total_video_sec: "Total durasi video (dtk)" };
